import { Injectable } from '@angular/core';
import { getStorage, ref, getBlob, deleteObject, uploadBytes, listAll } from 'firebase/storage';
import 'firebase/storage';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { FileAllegato } from '../models/storage/fileAllegato.model';
import {AngularFireStorageReference} from "@angular/fire/compat/storage";
import {StorageReference} from "@firebase/storage";

@Injectable({
    providedIn: 'root',
  })
export class GoogleStorageService {

  THUMBNAILS_BYEXT = {
    xls: "/assets/images/file_format/file_ms_excel.svg",
    xlsx: "/assets/images/file_format/file_ms_excel.svg",
    pdf: "/assets/images/file_format/file_adobe_pdf.svg"
  }

  async uploadAllegatoSegnalazioneToGoogleStorage(file: File, segnalazione: String): Promise<void> {
    const storage = getStorage();
    // console.log(">>>> CERCANDO DI SALVARE L'ALLEGATO  "+ file.name+ " DELLA SEGNALAZIONE "+segnalazione );
    const pathReference = ref(
        storage,
        'segnalazioni/'+segnalazione+"/"+file.name
      );
      // console.log(storage );

    const uploadTask =  await uploadBytes(pathReference,file).then(ok => {
      // console.log(">>>> OK SALVATAGGIO ALLEGATO "+ file.name+ " SEGNALAZIONE "+segnalazione );

    }).catch(error => {
      // console.log("failed salvataggio allegato: ", error);
      // console.log(">>>> KO FILE");
    });
  }
  async uploadAllegatoRapportinoToGoogleStorage(file: File, intervento: String): Promise<void> {
    const storage = getStorage();

    const pathReference = ref(
        storage,
        'interventi/'+intervento+"/"+file.name
      );
    const uploadTask =  await uploadBytes(pathReference,file).then(ok => {
      // console.log(">>>> OK SALVATAGGIO ALLEGATO "+ file.name+ " INTERVENTO "+intervento );

    }).catch(error => {
      // console.log("failed salvataggio allegato: ", error);
    });
  }

  buildDescrizioneAllegato (file: StorageReference, path: string) {
      const fileUrl = `https://storage.googleapis.com/${path}/${file.name}`;
      const allegato: FileAllegato = new FileAllegato();
      allegato.name = file.name;
      const file_parts = allegato.name.toLowerCase().split(".");
      const file_ext = file_parts[file_parts.length-1];
      // non abbiamo ulteriori dettagli
      allegato.alt = file.name;
      allegato.titolo = file.name;
      allegato.source = this.THUMBNAILS_BYEXT[file_ext] ?? fileUrl;
      allegato.thumbnailSource = this.THUMBNAILS_BYEXT[file_ext] ?? fileUrl;
      return allegato;
  }

  async getAllegatiRapportinoPerGalleria(intervento: String): Promise<FileAllegato[]> {
    const storage = getStorage();
    const folderReference = ref(storage, 'interventi/'+intervento);
    const options = {
      version: 'v4',
      action: 'read',
      expires: Date.now() + 15 * 60 * 1000, // 15 minuti
    };
    let listaFileAllegati:FileAllegato[]=[];
    try {
      const result = await listAll(folderReference);
      const attachpath = folderReference.bucket+"/interventi/"+intervento;
      if (result.items.length >= 1) {
        for (const file of result.items) {
          const allegato = this.buildDescrizioneAllegato(file, attachpath);
          // const urlFile = "https://storage.googleapis.com/"+folderReference.bucket+"/interventi/"+intervento+"/"+file.name;
          // let allegato:FileAllegato = new FileAllegato();
          // allegato.name = file.name;
          // allegato.alt="Descrizione alternativa";
          // allegato.titolo="Titolo";
          // allegato.source=urlFile;
          // allegato.thumbnailSource = urlFile;
          listaFileAllegati.push(allegato);
          // console.log(urlImmagine);
        }

      } else {
        // console.error('Nessun file nella cartela '+ intervento);
      }
    } catch (error) {
      // console.error('Error downloading files:', error);
    }
    return listaFileAllegati;
  }

  async getAllegatiPerGalleria(segnalazione: String): Promise<FileAllegato[]> {
    const storage = getStorage();
    const folderReference = ref(storage, 'segnalazioni/'+segnalazione);
    const options = {
      version: 'v4',
      action: 'read',
      expires: Date.now() + 15 * 60 * 1000, // 15 minuti
    };
    let listaFileAllegati:FileAllegato[]=[];
    try {
      const result = await listAll(folderReference);
      const attachpath = folderReference.bucket+"/segnalazioni/"+segnalazione;
      if (result.items.length >= 1) {
        for (const file of result.items) {
          const allegato = this.buildDescrizioneAllegato(file, attachpath);
          /*const urlImmagine = "https://storage.googleapis.com/"+folderReference.bucket+"/segnalazioni/"+segnalazione+"/"+file.name;
          let allegato:FileAllegato = new FileAllegato();
          const image = file.name
          allegato.name = file.name; // file name per download
          allegato.alt="Descrizione alternativa";
          allegato.titolo="Titolo"; // src per preview
          allegato.source=urlImmagine;
          allegato.thumbnailSource = urlImmagine; // src per preview
          */

          listaFileAllegati.push(allegato);
          // console.log(urlImmagine);
        }

      } else {
        // console.error('Nessun file nella cartela '+ segnalazione);
      }
    } catch (error) {
      // console.error('Error downloading files:', error);
    }
    return listaFileAllegati;
  }

  async downloadAllegatiSegnalazioneFromGoogleStorage(segnalazione: string): Promise<void> {
    const storage = getStorage();
    const folderReference = ref(storage, 'segnalazioni/'+segnalazione);
    // console.log("* downloadAllegatiSegnalazioneFromGoogleStorage "+ folderReference.fullPath);
    try {
      // List all files in the folder
      const result = await listAll(folderReference);

      if (result.items.length === 1) {
        // Se c'è un solo file, scaricalo direttamente
        const fileRef = result.items[0];
        const blob = await getBlob(fileRef);
        saveAs(blob, fileRef.name.replace(segnalazione, ''));
      } else if (result.items.length > 1) {
        // Se ci sono più file, crea un file zip
        const zip = new JSZip();

        for (const item of result.items) {
          const blob = await getBlob(item);
          const fileName = item.name.replace(segnalazione, '');
          zip.file(fileName, blob);
        }

        const zipContent = await zip.generateAsync({ type: 'blob' });
        saveAs(zipContent, `ALLEGATI_${segnalazione}.zip`);
      } else {
        // console.error('Nessun file nella cartela '+ segnalazione);
      }
    } catch (error) {
      // console.error('Error downloading files:', error);
    }

  }

  async downloadAllegatiInterventoromGoogleStorage(intervento: string): Promise<void> {
    const storage = getStorage();
    const folderReference = ref(storage, 'interventi/'+intervento);
    try {
      // List all files in the folder
      const result = await listAll(folderReference);

      if (result.items.length === 1) {
        // Se c'è un solo file, scaricalo direttamente
        const fileRef = result.items[0];
        const blob = await getBlob(fileRef);
        saveAs(blob, fileRef.name.replace(intervento, ''));
      } else if (result.items.length > 1) {
        // Se ci sono più file, crea un file zip
        const zip = new JSZip();

        for (const item of result.items) {
          const blob = await getBlob(item);
          const fileName = item.name.replace(intervento, '');
          zip.file(fileName, blob);
        }

        const zipContent = await zip.generateAsync({ type: 'blob' });
        saveAs(zipContent, `ALLEGATI_${intervento}.zip`);
      } else {
        // console.error('Nessun file nella cartela '+ intervento);
      }
    } catch (error) {
      // console.error('Error downloading files:', error);
    }

  }



  async deleteFileFromGoogleStorage(fileName:string) {
    const storage = getStorage();
    const pathReference = ref(
      storage,
      fileName
    );

    try {
        await deleteObject(pathReference);
        console.log("File eliminato con successo");
    } catch (error) {
        console.error("Errore durante l'eliminazione del file:", error);
    }
  }

  async downloadAllegatoSegnalazioneFromGoogleStorage(segnalazione:string, fileName: string): Promise<void> {
    const storage = getStorage();
    // console.log('segnalazioni/'+segnalazione+"/"+fileName);
    const pathReference = ref(
        storage,
        'segnalazioni/'+segnalazione+"/"+fileName
      );
      const blob = await getBlob(pathReference).then(ok => {
        console.log(">>>> OK DOWNLOAD FILE");

        return ok;
      }).catch(error => {
        console.log("failed salvataggio allegato: ", error);
      });
      saveAs(blob, segnalazione.toUpperCase()+"_"+fileName);
  }

  async downloadAllegatoInterventoFromGoogleStorage(intervento:string, fileName: string): Promise<void> {
    const storage = getStorage();
    // console.log('interventi/'+intervento+"/"+fileName);
    const pathReference = ref(
        storage,
        'interventi/'+intervento+"/"+fileName
      );
      const blob = await getBlob(pathReference).then(ok => {
        console.log(">>>> OK DOWNLOAD FILE");

        return ok;
      }).catch(error => {
       console.log("failed salvataggio allegato: ", error);
      });
      saveAs(blob, intervento.toUpperCase()+"_"+fileName);
  }

  async downloadFileFromGoogleStorage(fileName: string): Promise<void> {
    const storage = getStorage();

    const pathReference = ref(
        storage,
        fileName
      );
    getBlob(pathReference).then(ok => {
      console.log(">>>> OK DOWNLOAD FILE");

      return ok;
    }).catch(error => {
      console.log(">>>> KO DOWNLOAD FILE FILE");
    });
  }


}
